import { useSubscription } from "@apollo/client";
import { getMillLiveDowntimeReportSubscription } from "api/queries/liveDowntimeReportAPI";
import {
    ILastTwoShiftsMachineCentersInfoByMillResponse,
    ILastTwoShiftsEventsResponse,
    ILiveDowntimeReportEntity,
} from "./LiveDowntimeReportEntityInterfaces";
import { getLastTwoShiftsMachineCentersInfoByMill, getLastTwoShiftsEvents } from "api/queries/ShiftsAPI";
import { useMemo } from "react";

export const LiveDowntimeReportEntity: ILiveDowntimeReportEntity = {
    GetMillLiveDowntimeReportData: (mill_id) => {
        const subscriptionSetting = useMemo(
            () => ({
                variables: {
                    millId: mill_id,
                    productionLinesShiftsWhere: {
                        _or: [
                            {
                                disabled_at: { _gt: new Date().toISOString() },
                                effective_at: { _lte: new Date().toISOString() },
                            },
                            { disabled_at: { _is_null: true }, effective_at: { _lte: new Date().toISOString() } },
                        ],
                    },
                },
            }),
            [mill_id],
        );

        const { loading, error, data } = useSubscription(getMillLiveDowntimeReportSubscription, subscriptionSetting);
        let liveDowntimeReportData = [];
        if (data) {
            liveDowntimeReportData = data.machine_center;
        }
        return { loading, liveDowntimeReportData, error };
    },
    GetLastTwoShiftsEvents: async (machine_center_id, nowMillTimezone) => {
        try {
            const lastTwoShiftsEvents = (await getLastTwoShiftsEvents(
                machine_center_id,
                nowMillTimezone,
            )) as unknown as ILastTwoShiftsEventsResponse;

            if (lastTwoShiftsEvents.status === 200 && lastTwoShiftsEvents.data) {
                return lastTwoShiftsEvents.data;
            } else {
                return undefined;
            }
        } catch (error) {
            console.error(error);
        }
    },
    GetLastTwoShiftsMachineCentersInfoByMill: async (millId, nowMillTimezone) => {
        try {
            const lastTwoShiftsMachineCentersInfoByMill = (await getLastTwoShiftsMachineCentersInfoByMill(
                millId,
                nowMillTimezone,
            )) as unknown as ILastTwoShiftsMachineCentersInfoByMillResponse;

            if (lastTwoShiftsMachineCentersInfoByMill.status === 200 && lastTwoShiftsMachineCentersInfoByMill.data) {
                return lastTwoShiftsMachineCentersInfoByMill.data;
            } else {
                return undefined;
            }
        } catch (error) {
            console.error(error);
        }
    },
};
